export const CRM_FUNC_KEYS = 'CRM_FUNC_KEYS'; // 功能key

export const unlocking = (key) => {
  const controls = JSON.parse(localStorage.getItem(CRM_FUNC_KEYS));
  if (Object.prototype.toString.call(controls) !== '[object Array]') {
    return false;
  }
  return controls.some((item) => item && item.functionKey === key);
};
